'use client'

import { Button, Container, Dialog, Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  clickEvent,
  MANUAL_DELAYED_PUBLICATION_MODAL_SCREEN,
} from '@marketplace-web/delayed-publication/manual-delayed-publication-data'

import { SELLING_HELP_URL } from '../../constants/routes'

type Props = {
  isOpen: boolean
  onClose: () => void
}

const ManualDelayedPublicationModal = ({ isOpen, onClose }: Props) => {
  const translate = useTranslate('manual_delayed_publication.modal')

  const { track } = useTracking()

  const handleHelpCenterClick = () => {
    track(
      clickEvent({
        target: 'catalog_rules_faq',
        screen: MANUAL_DELAYED_PUBLICATION_MODAL_SCREEN,
      }),
    )
  }

  const renderTitle = () => (
    <Text as="h1" text={translate('title')} alignment="left" type="heading" />
  )

  const renderBody = () => (
    <Text
      as="span"
      text={translate('body', {
        'catalog-rules-link': chunks => (
          <a
            href={SELLING_HELP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleHelpCenterClick}
            data-testid="manual-delayed-publication-modal-help-center-link"
          >
            {chunks}
          </a>
        ),
      })}
      html
    />
  )

  const renderActions = () => (
    <Button
      text={translate('actions.close')}
      onClick={onClose}
      styling="filled"
      testId="manual-delayed-publication-modal-close-button"
    />
  )

  return (
    <Dialog show={isOpen} testId="manual-delayed-publication-modal">
      <Container>
        {renderTitle()}
        <Spacer size="large" />
        {renderBody()}
        <Spacer size="large" />
        {renderActions()}
      </Container>
    </Dialog>
  )
}

export default ManualDelayedPublicationModal
